import ApiService from "@/common/api.service";
export default {
  getIELTS(data) {
    return ApiService.query("ielts", data);
  },
  getTest(id) {
    return ApiService.query("ielts/questions/" + id, {
      is_created: 0
    });
  },
  postAnswer(userExam, data) {
    return ApiService.update("ielts/answer", userExam, data);
  },
  uploadAudio(data) {
    return ApiService.post("document", data);
  },
  getAllTranscripts(data) {
    return ApiService.query("ielts/transcripts", data);
  },
  getTranscript(id) {
    return ApiService.query(`ielts/transcript/${id}`);
  },
  getResolve(question_id, data) {
    return ApiService.get("ielts/question-exp", question_id, data);
  },
  finishedExam(id, data) {
    return ApiService.update("user-exam", id, data);
  },
  getQuestionCount() {
    return ApiService.get("ielts-question-count");
  },
  createOrder(data) {
    return ApiService.post("order", data);
  },
  getTransactions() {
    return ApiService.query("point-transactions");
  },
  openPackages() {
    return ApiService.query("packages");
  },
  getPointPackage(id) {
    return ApiService.query(`ielts-point-package/${id}`);
  },
  payForPackage(id, data) {
    return ApiService.post(`exam/${id}/pay-for-ielts-point-package`, data);
  },
  updateTranscript(id, data) {
    return ApiService.update("/ielts/grade", id, data);
  },
  getSubScoreCategories(skillType) {
    return ApiService.query("ielts/grade/comment-category", { type: skillType });
  },
  getNotification(data) {
    return ApiService.query("/ielts/not-score-notification/", data);
  },
  getTransactionsForcorrect(data) {
    return ApiService.query("/ielts/transcripts-for-correct", data);
  }
};
